import type { ReloginSecret } from "@/unlock";
import { ShieldCheck } from "lucide-react";
import { useState } from "react";
import { PinCreate } from "./PinCreate";

export const PIN_HONESTY =
  "En este teléfono queda guardada tu contraseña cifrada con el PIN: el PIN es lo único que la protege. Elegí seis dígitos que no sean tu cumpleaños y no se los pases a nadie.";

export function PinSetupScreen({
  ownerKey,
  secret,
  label,
  onDone,
  onSkip,
}: {
  ownerKey: string;
  secret: ReloginSecret;
  label: string;
  onDone: () => void;
  onSkip: () => void;
}) {
  const [creating, setCreating] = useState(false);

  return (
    <main className="login">
      <div className="login__card">
        {creating ? (
          <PinCreate
            ownerKey={ownerKey}
            secret={secret}
            label={label}
            onDone={onDone}
            onCancel={() => setCreating(false)}
          />
        ) : (
          <>
            <ShieldCheck size={28} aria-hidden="true" />
            <h1 className="t-h1">Entrá con un PIN</h1>
            <p className="t-body">
              La sesión vence cada tanto y en el campo escribir usuario y contraseña con una mano es
              un fastidio. Con un PIN de seis dígitos volvés a entrar en dos segundos.
            </p>
            <p className="notice notice--info">{PIN_HONESTY}</p>

            <button
              type="button"
              className="btn btn--primary btn--block"
              onClick={() => setCreating(true)}
            >
              Poner un PIN
            </button>
            <button type="button" className="btn btn--block" onClick={onSkip}>
              Ahora no
            </button>
            <p className="t-small">Si decís que no, lo podés poner cuando quieras desde "Yo".</p>
          </>
        )}
      </div>
    </main>
  );
}
